"use client";

import { useCallback, useState } from "react";

/** Minimal in-tab navigation stack — each Email Cleaner tab pushes/pops
 *  "screens" within itself rather than using site-level routes, since the
 *  whole app lives on one static page. */
export function useViewStack<T extends { name: string }>(root: T) {
  const [stack, setStack] = useState<T[]>([root]);

  const push = useCallback((view: T) => setStack((s) => [...s, view]), []);
  const pop = useCallback(() => setStack((s) => (s.length > 1 ? s.slice(0, -1) : s)), []);
  const reset = useCallback(() => setStack([root]), [root]);

  return { view: stack[stack.length - 1], depth: stack.length, push, pop, reset };
}
